<template>
  <div class="talk-main">
    <HomeNavgation v-if="isMobile"/>
    <transition name="fade">
      <FixedTalkHead 
        :info="info"
        :articleWxShareUrl="articleWxShareUrl"
        :isMobile="isMobile"
        :isFavorite="isFavorite"
        @goComment="goComment" 
        @toggleFavorite="toggleFavorite"
        @weiboShare="$emit('weiboShare')" 
        v-if="!isTalkHeadVisible" 
      />
    </transition>

    <div class="talk-head" ref="talkHead">
      <h1>
        <i class="iconfont">&#xe63a;</i>
        {{info.article_title | formatContent}}
      </h1>
      <div class="talk-detail">
        <div class="talk-detail-info">
          <div class="author-list">
            <span class="author-label">发起人：</span>
            <span class="author-wrap">
              <template v-for="(item, index) in info.author">
                <!-- <Avatar :src="item.avatar" :size="isMobile ? 20 : 24" /> -->
                <!-- <span class="author-name" v-if="item.no_author">{{item.no_author}}</span> -->
                <AuthorName class="author-name" :uid="item.uid" :name="item.nickname" v-if="index < 3" :key="index" />
              </template>
            </span>
          </div>
          <div class="views">{{info.comment_user}} 人讨论</div>
          <div class="lookers">{{info.views}} 人围观</div>
        </div>

        <template v-if="!isMobile">
          <div class="operation">
            <div :class="['share-btn', 'collection-btn', {'favorite': isFavorite}]" @click="toggleFavorite('talk-head')">
              <i class="iconfont">&#xe60b;</i> 
              收藏
            </div>
            <div class="share-btn comment-btn" @click="goComment">
              <i class="iconfont">&#xe643;</i> 评论
            </div>
            <div class="share-btn weixin" @mouseenter="touchWxStatus = true" @mouseleave="touchWxStatus = false">
              <i class="iconfont">&#xe63c;</i> 微信
              <transition name="slide-in-bottom">
                <div class="popup-box bottom" v-if="touchWxStatus">
                  <div class="popup-content">
                    <QrCode :size="87" :val="articleWxShareUrl" />
                  </div>
                </div>
              </transition>
            </div>
            <div class="share-btn weibo" @click="$emit('weiboShare')">
              <i class="iconfont">&#xe63b;</i> 微博
            </div>
          </div> 
        </template>
      </div>
    </div>

    <RichContent class="article-content" :title="info.article_title" :content="info.content" />
    <!-- 话题页面的 背景阅读 -->
    <div class="relation-read" v-if="info.relation_list.length">
      <h2>背景阅读</h2>
      <ul>
        <li v-for="(article, index) in info.relation_list" :key="index">
          <ArticleTitle :uuid="article.uuid || article.aid" :title="article.article_title" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import utils from '../../utils/'
import VisibleListener from 'gkSrc/utils/visible.listener'

import HomeNavgation from '../home/Home.Navgation'
import FixedTalkHead from './FixedTalkHead'
import QrCode from '../../components/qrcode'
import Avatar from '../../components/Avatar'
import AuthorName from '../../components/title/AuthorName'
import TopicTitle from '../../components/title/TopicTitle'
import ArticleTitle from '../../components/title/ArticleTitle'
import RichContent from './RichContent'

import ArticleService from '../../service/article.service'

export default {
  name: 'talk-content',
  components: {
    HomeNavgation,
    FixedTalkHead,
    QrCode,
    Avatar,
    AuthorName,
    TopicTitle,
    ArticleTitle,
    RichContent
  },
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      touchWxStatus: false,
      isFavorite: 0,
      isTalkHeadVisible: true
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser']),
    articleWxShareUrl () {
      return `https://www.infoq.cn${this.$route.path}?utm_source=wxshare`
    }
  },
  created () {
    utils.shareWeixin({
      title: this.info.article_title,
      desc: this.info.article_subtitle || this.info.article_summary,
      imgUrl: this.info.article_cover
    })
  },
  mounted () {
    this.initOpenInTab()
    this.listenTalkHeadVisible()
  },
  beforeDestroy () {
    this.io.clear()
  },
  methods: {
    /**
     * 监听话题头部是否可见，不可见时出现固定定位的  FixedTalkHead 组件
     */
    listenTalkHeadVisible () {
      this.io = new VisibleListener({scale: this.scale})

      this.io.add(this.$refs.talkHead, visible => {
        this.isTalkHeadVisible = visible
      })
    },
    /**
     * 给所有 a 标签添加 target属性 外链 新标签页打开
     */
    initOpenInTab () {
      let tags = document.querySelector('.talk-main').querySelectorAll('a')
      tags.forEach(item => {
        item.setAttribute('target', '_blank')
      })
    },
    /**
     * 收藏/取消收藏文章
     * @param {String}    position          触发收藏位置  用于GA统计
     */
    toggleFavorite (position) {
      !this.isFavorite && window.ga && window.ga('send', 'event', '话题新增收藏数', `${position}`)

      ArticleService.favoriteArticle(this.info.aid, !this.isFavorite).then(res => {
        this.isFavorite = !this.isFavorite
      })
    },
    /**
     * 跳转到到评价区
     */
    goComment () {
      this.$emit('goComment')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.talk-main {
  width: 100%;
}

.talk-head {
  position: relative;
  padding: 28px 24px 30px;
  background: #F3F9FF;
  border-radius: 3px;

  & h1 {
    position: relative;
    line-height: 38px;
    text-indent: 36px;
    color: $lightBlack;
    @include font(28, 500);

    & .iconfont {
      position: absolute; left: 0; top: 0;
      text-indent: 0;
      font-size: 28px;
      color: $blue;
      pointer-events: none;
    }
  }
}

.talk-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  padding-top: 10px;
  @include lineFont(14, 400);

  & .talk-detail-info {
    display: flex;
  }

  & .author-list {
    display: flex;
    padding-right: 20px;
    line-height: 17px;

    & .author-label {
      color: #828A92;
    }

    & .author-wrap {
      max-width: 98px;
      line-height: 17px;
      @extend %row;
    }

    & > div {
      @extend %center;
    }

    & .author-name:last-child {
      &:after {
        content: '';
        margin-right: 0;
      }
    }
  }

  & .author-name {
    // padding: 0 20px 0 0px;
    &:after {
      content: ',';
      display: inline-block;
      margin-right: 6px;
    }
  }


  & .views,
  & .lookers {
    position: relative;
    padding: 0 12px;
    line-height: 17px;
    color: #828A92;
  }

  & .views {
    padding-left: 0;

    &:after {
      content: '';
      display: block;
      position: absolute; top: 5px;
      width: 3px; height: 3px;
      background: #828A92;
      border-radius: 3px;
    }

    &:before {
      left: 0;
    }
    &:after {
      right: 0;
    }
  }

  & .operation {
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  & .share-label {
    padding-left: 18px;
    color: #828A92;
  }

  & .share-btn {
    position: relative;
    margin-left: 20px;
    cursor: pointer;
  }

  & .collection-btn {
    color: #828A92;

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: #F3B42C;
      }
    }
  }
  & .comment-btn {
    color: #828A92;

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: $blue;;
      }
    }

    & .iconfont {
      font-size: 14px;
    }
  }

  & .collection-btn.favorite {
    & .iconfont {
      color: #F3B42C;
    }
  }

  & .weibo {
    color: #828A92;

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: #EA5B48;;
      }
    }
  }

  & .weixin {
    position: relative;
    color: #828A92;
    cursor: pointer;

    &:hover {
      color: $grayHover;
      & .iconfont {
        color: #47C862;
      }
    }

    & .popup-box {
      position: absolute; top: 30px; z-index: 300;
      
      & .popup-content {
        box-sizing: border-box;
        position: relative;
        padding: 10px;
        background: #FFF;
        border: 1px solid $borderGray; border-radius: 3px;
        box-shadow: $shadowGray;
        cursor: default;

        &:before,
        &:after {
          content: ' ';
          display: block;
          position: absolute;
          width: 0; height: 0;
        }

      }

      &.bottom {
        left: -28px;
        // padding-bottom: 60px;

        & .popup-content {
          &:before,
          &:after {
            left: 50%;
            transform: translateX(-50%);
          }

          &:before {
            top: -9px;
            border-bottom: 8px solid $borderGray;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }

          &:after {
            top: -8px;
            border-bottom: 8px solid #FFF;
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
          }
        }
        
      }
    }
  }
}

.article-content {
  padding-top: 20px;
}

.relation-read {
  & h2 {
    margin-bottom: 10px;
    @include lineFont(16, 500);
    color: $lightBlack;
  }

  & ul {
    & li {
      position: relative;
      padding-left: 17px;
      line-height: 28px;

      &:before {
        content: "";
        position: absolute; left: 0; top: 10px;
        width: 5px; height: 5px;
        background: $blue;
        border-radius: 50%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .talk-main {
    display: flex;
    flex-direction: column;
  }

  .talk-head {
    padding: 24px 14px 28px;

    & h1 {
      line-height: 30px;
      text-indent: 27px;
      @include font(21, 500);

      & .iconfont {
        font-size: 20px;
      }
    }
  }

  .talk-detail {
    justify-content: flex-start;
    align-items: center;
    height: 20px;
    padding-top: 10px;
    @include font(13, 400);

    & .author-name {
      // padding: 0 14px 0 8px;
    }

    & .views {
      flex: 1;
      padding: 0;
      text-align: right;
      color: #828A92;

      &:before,
      &:after {
        display: none;
      }
    }

    & .lookers {
      padding-right: 0;
    }
  }

  .article-content {
    padding-top: 12px;
  }

  .relation-read {

    & ul {
      & li {
        padding-left: 16px;

        & ::v-deep .com-article-title {
          color: $blue;
        }
      }
    }
  }
}

.slide-in-bottom-enter-active,
.slide-in-bottom-leave-active {
  transition: all 0.3s ease;
}
.slide-in-bottom-enter,
.slide-in-bottom-leave-to {
  transform: translateY(-5px);
  opacity: 0;
}
</style>

 